import { memo, useCallback } from "react";
import PropTypes from "prop-types";
import "./BackButton.scss";
import { FormattedMessage } from "react-intl";
import RelativeLink from "app/pages/.shared/RelativeLink";
import IconBack from "app/pages/.shared/static/icons/IconBack";
import { sendTagOnBackButton } from "app/utils/analytics";
import { useLocation, useNavigate } from "react-router-dom";

const BackButtonComponent = ({ to, label, forceBrowserBack, onClick }) => {
	const { pathname } = useLocation();
	const navigate = useNavigate();

	const handleClick = useCallback(() => {
		sendTagOnBackButton(pathname);
		onClick();
	}, [pathname, onClick]);

	const backHistory = useCallback(() => {
		if (typeof window !== "undefined") {
			onClick();
			navigate(-1);
		}
	}, [onClick, navigate]);

	if (forceBrowserBack) {
		return (
			<div className="back-button" onClick={backHistory} data-testid="back-button">
				<IconBack width={15} height={15} style={{ marginRight: "5px" }} />
				<div className="back-button__label">{label && <FormattedMessage id={label} />}</div>
			</div>
		);
	}

	return (
		<div className="back-button">
			<RelativeLink
				variant="naked"
				to={{ ...to }}
				replace
				onClick={handleClick}
				data-testid="back-button"
			>
				<IconBack width={15} height={15} style={{ marginRight: "5px" }} />
				<div className="back-button__label">{label && <FormattedMessage id={label} />}</div>
			</RelativeLink>
		</div>
	);
};

BackButtonComponent.propTypes = {
	to: PropTypes.object,
	onClick: PropTypes.func,
	label: PropTypes.string,
	forceBrowserBack: PropTypes.bool,
};

BackButtonComponent.defaultProps = {
	onClick: () => {},
	to: {},
};

export const BackButton = memo(BackButtonComponent);
